"use client";

import { useTranslations } from "next-intl";
import React, { useEffect, useMemo, useState } from "react";
import { Progress } from "@/components/ui/progress";
import type { DietCatalogDetail } from "@/features/diets/types";
import type { ConfigureDietReturnFormType } from "../../forms/configure-diet";

export const MealsBar = ({
  diet,
  form,
}: {
  diet: DietCatalogDetail;
  form: ConfigureDietReturnFormType;
}) => {
  const t = useTranslations();
  const kcal = form.getValues("kcal");
  const meals = form.getValues("meals");
  const currentCalorifics = useMemo(
    () => diet.calorifics.find((c) => c.calories === Number(kcal)),
    [kcal],
  );
  const [percentage, setPercentage] = useState(0);
  const [selectedCalorifics, setSelectedCalorifics] = useState(0);

  const getPercentage = () => {
    const selectedMealsKcal = currentCalorifics?.mealsCaloricValue?.reduce(
      (acc, curr) => {
        if (meals.includes(curr.mealId)) {
          return acc + curr.caloricity;
        }
        return acc;
      },
      0,
    );
    setSelectedCalorifics(Number(selectedMealsKcal));
    return (Number(selectedMealsKcal) / Number(kcal)) * 100;
  };

  useEffect(() => {
    setPercentage(getPercentage());
  }, [meals, kcal]);

  return (
    <div className="mt-4 flex flex-col rounded-lg bg-white px-4 py-5">
      <header className="order-2 flex flex-col gap-1 md:order-none md:mb-2 md:flex-row md:items-center md:gap-4">
        <p className="flex items-center justify-between gap-1">
          {t("cart.configuration.meals_amount")}:<strong>{meals.length}</strong>
        </p>
        <p className="flex items-center justify-between gap-1">
          {t("cart.configuration.calories")}:
          <strong>{selectedCalorifics} kcal</strong>
        </p>
      </header>
      <Progress
        value={percentage}
        className="order-1 mt-2 mb-4 h-[5px] bg-brand-grey2 md:order-none md:mt-0 md:mb-0 [&_>div]:bg-brand-green2-300 [&_>div]:transition-none"
      />
    </div>
  );
};
